import { z } from 'zod'

export const ADMINDESKTOPAGENTSPOST_CONTRACT_VERSION = '1.0.0' as const
export const adminDesktopAgentsPostResponseSchema = z.unknown()
export type AdminDesktopAgentsPostResponse = z.infer<typeof adminDesktopAgentsPostResponseSchema>
